/* eslint-disable global-require */
module.exports = ['artprice.landingpages.services.header.m1'];
